export const getInstructorMetrics = async () => {
  return {
    questionsSubmitted: 150,
    testsSubmitted: 25,
    studentSuccessRate: '85%',
    earnings: 25000,
    totalStudents: 450,
    averageRating: 4.8,
    topPerformingTests: [
      { id: 1, name: 'Advanced JavaScript', successRate: '92%', studentCount: 120 },
      { id: 2, name: 'React Fundamentals', successRate: '88%', studentCount: 95 },
      { id: 3, name: 'Data Structures', successRate: '82%', studentCount: 75 }
    ],
    revenueData: {
      monthly: [
        { month: 'Jan', amount: 3200 },
        { month: 'Feb', amount: 4100 },
        { month: 'Mar', amount: 3800 },
        { month: 'Apr', amount: 4500 },
        { month: 'May', amount: 5200 },
        { month: 'Jun', amount: 4800 }
      ],
      byCategory: [
        { category: 'Programming', amount: 12000 },
        { category: 'Web Development', amount: 8500 },
        { category: 'Data Science', amount: 6800 },
        { category: 'Cloud Computing', amount: 5500 }
      ]
    },
    recentActivity: [
      { type: 'test_submission', message: 'New submission for Advanced JavaScript Test', time: '2 hours ago' },
      { type: 'student_feedback', message: 'New feedback received for React Course', time: '4 hours ago' },
      { type: 'earnings', message: 'Earned $150 from Python Basics Test', time: '1 day ago' },
      { type: 'student_query', message: 'New question about Data Structures Test', time: '1 day ago' }
    ],
    upcomingSchedule: [
      { type: 'test_deadline', title: 'JavaScript Advanced Test closes', date: '2024-02-10' },
      { type: 'review_pending', title: 'Review Python Test submissions', date: '2024-02-12' },
      { type: 'new_test', title: 'Launch React Native Test', date: '2024-02-15' }
    ],
    studentEngagement: {
      daily: [
        { date: '2024-02-01', activeStudents: 85 },
        { date: '2024-02-02', activeStudents: 92 },
        { date: '2024-02-03', activeStudents: 78 },
        { date: '2024-02-04', activeStudents: 95 },
        { date: '2024-02-05', activeStudents: 88 }
      ],
      byTimeOfDay: [
        { hour: '9AM', count: 45 },
        { hour: '12PM', count: 75 },
        { hour: '3PM', count: 65 },
        { hour: '6PM', count: 85 },
        { hour: '9PM', count: 55 }
      ]
    }
  };
};

export const getRecommendations = async () => {
  return {
    trendingTopics: [
      { 
        topic: 'Machine Learning',
        requestCount: 250,
        potentialEarnings: 15000,
        marketAnalysis: {
          demandGrowth: '+45%',
          competitionLevel: 'Medium',
          averageTestPrice: 49.99,
          studentInterest: 'High',
          industryRelevance: 'Growing field in tech industry'
        }
      },
      { 
        topic: 'React Native',
        requestCount: 180,
        potentialEarnings: 12000,
        marketAnalysis: {
          demandGrowth: '+35%',
          competitionLevel: 'Low',
          averageTestPrice: 39.99,
          studentInterest: 'High',
          industryRelevance: 'High demand for mobile developers'
        }
      },
      { 
        topic: 'System Design',
        requestCount: 150,
        potentialEarnings: 10000,
        marketAnalysis: {
          demandGrowth: '+30%',
          competitionLevel: 'Medium',
          averageTestPrice: 59.99,
          studentInterest: 'Medium',
          industryRelevance: 'Critical for senior roles'
        }
      }
    ],
    gapAreas: [
      { 
        topic: 'Blockchain',
        demandScore: 9.5,
        competitorCount: 3,
        insights: {
          skillGap: 'High',
          marketPotential: 'Growing',
          suggestedTopics: ['Smart Contracts', 'DeFi', 'Web3'],
          difficultyLevel: 'Advanced',
          estimatedPreparationTime: '4-6 weeks'
        }
      },
      { 
        topic: 'Cloud Architecture',
        demandScore: 9.2,
        competitorCount: 5,
        insights: {
          skillGap: 'Medium',
          marketPotential: 'Very High',
          suggestedTopics: ['AWS', 'Azure', 'Microservices'],
          difficultyLevel: 'Intermediate to Advanced',
          estimatedPreparationTime: '3-5 weeks'
        }
      },
      { 
        topic: 'DevOps',
        demandScore: 8.8,
        competitorCount: 4,
        insights: {
          skillGap: 'Medium',
          marketPotential: 'High',
          suggestedTopics: ['CI/CD', 'Docker', 'Kubernetes'],
          difficultyLevel: 'Intermediate',
          estimatedPreparationTime: '4-8 weeks'
        }
      }
    ],
    studentFeedback: [
      { topic: 'AI/ML', requestCount: 45, commonFeedback: 'Need more practical exercises' },
      { topic: 'Cloud', requestCount: 38, commonFeedback: 'Want hands-on AWS projects' },
      { topic: 'Security', requestCount: 32, commonFeedback: 'Need basic to advanced path' }
    ]
  };
};

export const getTestHistory = async () => {
  return [
    {
      id: 1,
      name: 'Advanced JavaScript Concepts',
      category: 'Programming',
      createdAt: '2024-02-01',
      totalAttempts: 89,
      averageScore: 82,
      status: 'active',
      questions: 25,
      stats: {
        completionRate: 95,
        averageTime: 45, // minutes
        difficultyDistribution: {
          easy: 30,
          medium: 45,
          hard: 25
        },
        topPerformingQuestions: [
          { id: 1, correctRate: 95, topic: 'Closures' },
          { id: 2, correctRate: 92, topic: 'Promises' }
        ],
        challengingQuestions: [
          { id: 3, correctRate: 45, topic: 'Prototypes' },
          { id: 4, correctRate: 52, topic: 'Event Loop' }
        ],
        recentSubmissions: [
          { date: '2024-02-07', score: 85, time: 42 },
          { date: '2024-02-06', score: 78, time: 38 }
        ]
      }
    },
    {
      id: 2,
      name: 'React State Management',
      category: 'Web Development',
      createdAt: '2024-01-25',
      totalAttempts: 65,
      averageScore: 78,
      status: 'active',
      questions: 20,
      stats: {
        completionRate: 88,
        averageTime: 35,
        difficultyDistribution: {
          easy: 35,
          medium: 40,
          hard: 25
        },
        topPerformingQuestions: [
          { id: 5, correctRate: 90, topic: 'useState' },
          { id: 6, correctRate: 88, topic: 'useEffect' }
        ],
        challengingQuestions: [
          { id: 7, correctRate: 48, topic: 'useReducer' },
          { id: 8, correctRate: 55, topic: 'Custom Hooks' }
        ],
        recentSubmissions: [
          { date: '2024-02-07', score: 82, time: 33 },
          { date: '2024-02-06', score: 75, time: 38 }
        ]
      }
    },
    {
      id: 3,
      name: 'Data Structures Basics',
      category: 'Computer Science',
      createdAt: '2024-01-15',
      totalAttempts: 120,
      averageScore: 75,
      status: 'active',
      questions: 30,
      stats: {
        completionRate: 92,
        averageTime: 50,
        difficultyDistribution: {
          easy: 25,
          medium: 50,
          hard: 25
        },
        topPerformingQuestions: [
          { id: 9, correctRate: 92, topic: 'Arrays' },
          { id: 10, correctRate: 88, topic: 'Linked Lists' }
        ],
        challengingQuestions: [
          { id: 11, correctRate: 42, topic: 'Trees' },
          { id: 12, correctRate: 48, topic: 'Graphs' }
        ],
        recentSubmissions: [
          { date: '2024-02-07', score: 72, time: 48 },
          { date: '2024-02-06', score: 78, time: 52 }
        ]
      }
    }
  ];
};

export const getCommunityStats = async () => {
  return {
    totalMembers: 1200,
    activeDiscussions: 45,
    yourContributions: 28,
    recentTopics: [
      { title: 'Best practices for React hooks', engagement: 156 },
      { title: 'System design interview tips', engagement: 142 },
      { title: 'Machine learning career path', engagement: 128 }
    ]
  };
};

export const getTestCategories = async () => {
  return [
    { id: 1, name: 'Programming', subcategories: ['JavaScript', 'Python', 'Java', 'C++'] },
    { id: 2, name: 'Web Development', subcategories: ['Frontend', 'Backend', 'Full Stack', 'DevOps'] },
    { id: 3, name: 'Data Science', subcategories: ['Machine Learning', 'Data Analysis', 'Statistics', 'Big Data'] },
    { id: 4, name: 'Computer Science', subcategories: ['Algorithms', 'Data Structures', 'Operating Systems', 'Networking'] },
    { id: 5, name: 'Cloud Computing', subcategories: ['AWS', 'Azure', 'Google Cloud', 'Docker'] }
  ];
};

export const parseExcelQuestions = async (file) => {
  // Mock function to simulate Excel parsing
  // In reality, you would use a library like xlsx to parse the file
  return {
    success: true,
    data: [
      {
        question: 'What is JavaScript?',
        answers: ['A programming language', 'A markup language', 'A database', 'A server'],
        correctAnswer: 0,
        topic: 'JavaScript Basics',
        difficulty: 'medium',
        hints: 'Think about web browsers',
        image: null
      },
      {
        question: 'What is React?',
        answers: ['A framework', 'A library', 'A database', 'A language'],
        correctAnswer: 1,
        topic: 'React Fundamentals',
        difficulty: 'hard',
        hints: 'Created by Facebook',
        image: null
      }
    ],
    errors: []
  };
};

export const getStudentPerformanceData = async () => {
  return {
    monthlyData: [
      { month: 'Jan', successRate: 82 },
      { month: 'Feb', successRate: 85 },
      { month: 'Mar', successRate: 87 },
      { month: 'Apr', successRate: 84 },
      { month: 'May', successRate: 89 },
      { month: 'Jun', successRate: 91 }
    ],
    performanceByTopic: [
      { topic: 'JavaScript', successRate: 88 },
      { topic: 'React', successRate: 85 },
      { topic: 'Node.js', successRate: 82 },
      { topic: 'Data Structures', successRate: 79 },
      { topic: 'Algorithms', successRate: 81 }
    ]
  };
};
